import { Component, inject, ViewEncapsulation } from '@angular/core';
import { ConnectivityService } from '../../core/services/connectivity.service';
import { TranslatePipe } from '../pipes/translate.pipe';

@Component({
  selector: 'app-offline-banner',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './offline-banner.component.html',
  styleUrls: ['./offline-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OfflineBannerComponent {
  protected connectivity = inject(ConnectivityService);
}
